"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var index_scss_1 = __importDefault(require("./index.scss"));
exports.default = {
    date_time_picker_button_border_radius: index_scss_1.default.date_time_picker_button_border_radius,
    date_time_picker_button_font_size: index_scss_1.default.date_time_picker_button_font_size,
    date_time_picker_button_padding: index_scss_1.default.date_time_picker_button_padding,
    date_time_picker_button_position: index_scss_1.default.date_time_picker_button_position,
    date_time_picker_border_radius: index_scss_1.default.date_time_picker_border_radius,
    date_time_picker_clock_arrow_switcher_spacer_width: index_scss_1.default.date_time_picker_clock_arrow_switcher_spacer_width,
    date_time_picker_clock_button_border_radius: index_scss_1.default.date_time_picker_clock_button_border_radius,
    date_time_picker_clock_button_bottom: index_scss_1.default.date_time_picker_clock_button_bottom,
    date_time_picker_clock_button_size: index_scss_1.default.date_time_picker_clock_button_size,
    date_time_picker_clock_height: index_scss_1.default.date_time_picker_clock_height,
    date_time_picker_clock_margin_top: index_scss_1.default.date_time_picker_clock_margin_top,
    date_time_picker_clock_scale: index_scss_1.default.date_time_picker_clock_scale,
    date_time_picker_clock_scale_mobile: index_scss_1.default.date_time_picker_clock_scale_mobile,
    date_time_picker_clock_thumb_border_size: index_scss_1.default.date_time_picker_clock_thumb_border_size,
    date_time_picker_clock_width: index_scss_1.default.date_time_picker_clock_width,
    date_time_picker_clock_width_mobile: index_scss_1.default.date_time_picker_clock_width_mobile,
    date_time_picker_input_min_width: index_scss_1.default.date_time_picker_input_min_width,
};
